import support from "../utilities/BrowserSupport.js";
import Emitter from "../utilities/Emitter.js";

class Window {
  constructor() {
    this.width = null;
    this.height = null;

    this.halfWidth = null;
    this.halfHeight = null;

    this.isMobile = null;
    this.isIpad = null;
    this.isTablet = null;
    this.isTouch = null;

    this.scrollEnable = true;

    this.scroll =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop;
    this.smoothScroll = this.scroll;

    this.resize();

    // Listen global events
    window.addEventListener("scroll", this.onScroll.bind(this), false);
    Emitter.on("resize", this.resize.bind(this));
  }

  resize() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;

    this.halfWidth = this.width / 2;
    this.halfHeight = this.height / 2;

    this.isMobile = window.innerWidth < 47.9375 * 16;
    this.isTablet = window.innerWidth < 63.9375 * 16;
    this.isBigScreen = window.innerWidth > 2200;
    this.isTouch = support.touch;
  }

  onScroll() {
    this.scroll =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop;
  }

  update() {}
}

const dataWindow = new Window();

export default dataWindow;



// WEBPACK FOOTER //
// ./resources/assets/js/stores/Window.js